import React, { SVGProps } from 'react'

export const ThirdActiveLeftSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="36"
    viewBox="0 0 16 36"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.01 20.003C.354 33.656 12 36 16 36V2C8.536 3.309-.323 6.897.01 20.003Z"
    />
  </svg>
)
